﻿import { firmwareOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("firmware"),
  endpoint: "firmware",
  operations: firmwareOps,
  roleView: [ROLE.FIRMWARE_VIEW, ROLE.FIRMWARE_ADMIN],
  roleAdmin: [ROLE.FIRMWARE_ADMIN],
  singularName: (t) => t("Firmware"),
  name: (t) => t("Firmware"),
  disableHotKeys: true,
  syncCustomerFilter: true,
  initialFilter: {
    "status": "public"
  }
});

export default conf;
